export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=An%20artistic%20stylized%20digital%20illustration%20of%20a%20young%20person%20comfortably%20reading%20colorful%20manga%20on%20a%20tablet%20in%20a%20cozy%20modern%20room%20with%20warm%20ambient%20lighting%2C%20surrounded%20by%20floating%20comic%20panels%20and%20speech%20bubbles%20in%20soft%20pink%20and%20coral%20tones%2C%20clean%20minimal%20background%20with%20gentle%20gradient%20from%20warm%20cream%20to%20soft%20peach%2C%20contemporary%20flat%20design%20digital%20art%20style%20with%20manga%20inspired%20decorative%20elements%20scattered%20harmoniously%20around%20the%20composition%2C%20inviting%20and%20energetic%20atmosphere&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="妖精动漫在线阅读 - 韩漫日漫国漫免费看"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-sm font-medium text-white bg-primary-500/90 rounded-full mb-5">
              🔥 每日更新 · 稳定在线
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              妖精动漫 — 免费在线看韩漫日漫国漫全集
            </h1>

            <p className="text-base md:text-lg text-white/85 mb-4 font-medium">
              下拉式阅读，追更收藏一站搞定
            </p>

            <p className="text-sm md:text-base text-white/70 max-w-[560px] mx-auto lg:mx-0 leading-relaxed mb-6">
              妖精动漫网专注提供最新最全的韩漫、日漫、国漫免费在线阅读服务。平台每日同步更新热门连载，支持流畅的下拉式阅读体验。无论你是偏爱韩国漫画的精致画风，还是钟情于日本漫画的经典叙事，亦或是热爱国产漫画的崛起之作，妖精动漫都能满足你的阅读需求，让你随时随地畅享漫画世界。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-book-read-line text-lg text-accent-400"></i>
                <span>2000+ 部作品持续连载</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-global-line text-lg text-accent-400"></i>
                <span>韩漫日漫国漫全覆盖</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-shield-check-line text-lg text-accent-400"></i>
                <span>极速加载 · 安全稳定</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-semibold rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors text-center text-sm"
              >
                开始追漫
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-white/15 text-white font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors text-center text-sm backdrop-blur-sm"
              >
                热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20stylized%20illustration%20of%20an%20open%20manga%20book%20floating%20in%20mid%20air%20with%20vibrant%20colored%20comic%20panels%20bursting%20out%20like%20magic%2C%20surrounded%20by%20twinkling%20stars%20and%20soft%20cherry%20blossom%20petals%2C%20warm%20peach%20and%20cream%20background%20with%20delicate%20gradient%2C%20whimsical%20and%20enchanting%20atmosphere%2C%20modern%20flat%20design%20illustration%20style%20with%20clean%20lines%20and%20soft%20shadows%2C%20perfect%20for%20a%20manga%20reading%20platform%20hero%20visual&width=800&height=600&seq=hero-right-01&orientation=landscape"
                alt="妖精动漫平台 - 漫画阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}